var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElasticsearchService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00a9e5",
    d: "M33.5 18H23.05c.05.25.15.5.2.7.35 1.2.55 2.45.65 3.75.05.5.05 1.05.05 1.55s0 1.05-.05 1.55c-.1 1.3-.3 2.55-.65 3.75-.05.25-.15.5-.2.7H33.5c3.3 0 5.95-2.7 5.95-6s-2.65-6-5.95-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    d: "M23.9 25.55c.05-.5.05-1.05.05-1.55s0-1.05-.05-1.55c-.1-1.3-.3-2.55-.65-3.75-.05-.25-.15-.5-.2-.7H6.9c-.6 1.9-.9 3.9-.9 6s.3 4.1.9 6h16.15c.05-.25.15-.5.2-.7.35-1.2.55-2.45.65-3.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00bfb3",
    d: "M35.3 32h-13c-.4.9-.85 1.75-1.35 2.55-.75 1.25-1.65 2.35-2.65 3.4-.35.35-.7.65-1.05 1-.7.65-1.5 1.2-2.3 1.75 3.15 2.1 6.95 3.3 11 3.3C32.9 44 39 40.45 42.6 35.1c-1.85-1.9-4.45-3.1-7.3-3.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#019b8f",
    d: "M20.95 34.55c.5-.8.95-1.65 1.35-2.55H7.65c1.55 3.55 4.1 6.6 7.35 8.7.8-.55 1.55-1.1 2.3-1.75.35-.3.7-.65 1.05-1 .95-1 1.85-2.15 2.6-3.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9b110",
    d: "M18.3 10.05c-.35-.35-.7-.65-1.05-1-.7-.65-1.5-1.2-2.3-1.75-3.2 2.1-5.75 5.15-7.35 8.7h14.65c-.4-.9-.85-1.75-1.35-2.55-.7-1.25-1.6-2.4-2.6-3.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed10a",
    d: "M25.95 4c-4.05 0-7.85 1.2-11 3.3.8.55 1.55 1.1 2.3 1.75.35.3.7.65 1.05 1 1 1.05 1.9 2.15 2.65 3.4.5.8.95 1.65 1.35 2.55h13c2.85 0 5.45-1.2 7.3-3.1C39 7.55 32.9 4 25.95 4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElasticsearchService);
export default __webpack_public_path__ + "static/media/elasticsearchService.6c2c7f2f7b4d1d35eb583603451645a3.svg";
export { ForwardRef as ReactComponent };